import { HelmetProvider } from 'react-helmet-async'

// Contexts
import { SaveProvider } from 'src/store/save/Store'
import { FightProvider } from 'src/store/fights/Store'
import { EventProvider } from 'src/store/events/Store'
import { NPCProvider } from 'src/store/npcs/Store'
import { ItemProvider } from 'src/store/items/Store'
import { LogProvider } from 'src/store/logs/Store'
import { MapProvider } from 'src/store/map/Store'
import { NavigationProvider } from 'src/store/navigation/Store'
import { InventoryProvider } from 'src/store/inventory/Store'
import { LocationProvider } from 'src/store/locations/Store'
import { StatsProvider } from './store/stats/Store'
import ThemeProvider from 'src/theme'

// components
import Home from 'src/pages/Home'
// ----------------------------------------------------------------------

const helmetContext = {}

export default function App () {
  return (
    <HelmetProvider context={helmetContext}>
    <ThemeProvider>
      <FightProvider>
        <SaveProvider>
          <EventProvider>
            <NPCProvider>
              <ItemProvider>
                <LogProvider>
                  <NavigationProvider>
                    <InventoryProvider>
                      <MapProvider>
                        <LocationProvider>
                          <StatsProvider>
                            <Home/>
                          </StatsProvider>
                        </LocationProvider>
                      </MapProvider>
                    </InventoryProvider>
                  </NavigationProvider>
                </LogProvider>
              </ItemProvider>
            </NPCProvider>
          </EventProvider>
        </SaveProvider>
      </FightProvider>
    </ThemeProvider>
    </HelmetProvider>
  )
}
